export default function accordion () {
  var dd = window.$('dd')
  dd.filter(':nth-child(n+4)').hide()
  window.$('dl.accordion').on('click', 'dt', function () {
    window.$(this).addClass('active').siblings('dt').removeClass('active')

    window.$(this).next().slideDown(200).siblings('dd').slideUp(300)
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/accordion.js